import type { TypeUsage } from '@/core/types/library.type'

import { isAccessorMetadataNode } from '../isAccessorMetadataNode'

import { formatTypeUsage } from './formatTypeUsage'
import { safeString } from './safeString'

export const getDeclaringType = (rawDeclaringType: unknown): string | undefined => {
  if (rawDeclaringType == null) {
    return undefined
  }

  if (isAccessorMetadataNode(rawDeclaringType)) {
    return undefined
  }

  if (typeof rawDeclaringType === 'object' && Array.isArray((rawDeclaringType as TypeUsage).payload)) {
    return formatTypeUsage(rawDeclaringType as TypeUsage)
  }

  if (typeof rawDeclaringType === 'string') {
    return safeString(rawDeclaringType)
  }

  return undefined
}
